package nl.staartvin.solarpower.data.chart

/**
 * WHO/RIVM UV index severity bands. The integer color components are exposed
 * so each platform can build its own Color: Compose `Color(r, g, b)`,
 * SwiftUI `Color(red: r/255, green: g/255, blue: b/255)`.
 *
 * Sharing typed colors across Kotlin and Swift would require either a wrapper
 * type (defeats the point) or platform-specific Color types (defeats sharing).
 * Raw RGB ints are the lowest common denominator.
 */
enum class UvSeverity(val r: Int, val g: Int, val b: Int, val displayName: String) {
    Low(40, 149, 0, "Low"),                  // green
    Moderate(247, 228, 0, "Moderate"),       // yellow
    High(248, 89, 0, "High"),                // orange
    VeryHigh(216, 0, 29, "Very High"),       // red
    Extreme(107, 73, 200, "Extreme");        // violet

    companion object {
        /** Maps a UV index value to its severity band. Boundaries per WHO. */
        fun forUvi(uvi: Double): UvSeverity = when {
            uvi < 3 -> Low
            uvi < 6 -> Moderate
            uvi < 8 -> High
            uvi < 11 -> VeryHigh
            else -> Extreme
        }
    }
}
